export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'Nombre Oferta',
        value: 'name',
    },
    {
        text: 'Cantidad Productos',
        value: 'product_quantity',
    },
    {
        text: 'Fecha Inicio',
        value: 'init_datetime',
    },
    {
        text: 'Fecha Término',
        value: 'finish_datetime',
    },
]
